import React, { useState } from 'react';

import { Box, Button, Container, Stack, Typography } from '@mui/material';
import { graphql, navigate } from 'gatsby';
import { useTranslation } from 'react-i18next';

import { ParkingLotSelect } from '../../features/Parking/components/parking-lots-select';
import { useParkingLots } from '../../features/Parking/hooks';
import { Tab } from '../Tab';
import { Tabs } from '../Tabs';
import TabPanel from '../TabPanel';

// ********************************************************************************
export const parkingPriceMapping = (props: any, locale: string) => {
  return {};
};
type Props = {};
export const ParkingPrice: React.FC<Props> = () => {
  const { t } = useTranslation();
  const { parkingLotsWithReservation, parkingLotsDriveIn } = useParkingLots(false);

  // == State =====================================================================
  const [parkinLotType, setParkingLotType] = useState(0); /** With Reservation || Drive-In */

  // == Handlers ==================================================================
  const handleParkingLotTypeChange = (_: any, newValue: number) => {
    setParkingLotType(newValue);
  };

  // == Render =====================================================================
  return (
    <Box bgcolor="white" py={6}>
      <Container maxWidth="lg">
        <Stack spacing={5}>
          <Stack spacing={3}>
            <Typography variant="h2" color="#3F2B56" fontFamily="Gotham-Medium" fontSize="32px" align="left">
              {t('parking_service.parking_price.title')}
            </Typography>
            <Typography variant="body1" color="#302F2F" fontSize="18px" textAlign="left" lineHeight="20px" mt={2}>
              {t('parking_service.parking_price.description')}
            </Typography>

            <Button
              variant="contained"
              color="primary"
              size="large"
              sx={{
                maxWidth: '233px',
              }}
              onClick={() => navigate('/#parking')}
            >
              {t('parking_service.parking_price.button')}
            </Button>
          </Stack>
          <Tabs
            value={parkinLotType}
            onChange={handleParkingLotTypeChange}
            aria-label="lots-tabs"
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab label={t('parking_service.reservation_required')} />
            <Tab label={t('parking_service.no_reservation_required')} />
          </Tabs>
          <TabPanel value={parkinLotType} index={0}>
            <ParkingLotSelect
              sections={parkingLotsWithReservation}
              parkingPrice={null}
              numbersOfVehicles={0}
              onSelect={() => { }}
            />
          </TabPanel>
          <TabPanel value={parkinLotType} index={1}>
            <ParkingLotSelect
              sections={parkingLotsDriveIn}
              parkingPrice={null}
              numbersOfVehicles={0}
              onSelect={() => { }}
            />
          </TabPanel>
        </Stack>
      </Container>
    </Box>
  );
};

/**
 * GraphQL Query
 */
export const query = graphql`
  fragment ParkingPrice on StrapiWidgetrels {
    parkingPrice {
      key: id
      widgetPosition
    }
  }
`;
